import { useEffect, useState } from "react";
import { BbotButton, SettingsCard } from "top-component-library";
import TemporarilyDisableOrderingDialog from "./TemporarilyDisableOrderingDialog";

// Mirrors edit-hostname-configs.html's "Temporarily disable ordering" block.
const TemporarilyDisableOrderingCard = ({
  hostnameConfig,
  onTemporarilyDisableOrdering,
  fetchTemporaryDisableText,
}) => {
  const { configType, canEdit, most_recent_root_template_instance: isDisabled } = hostnameConfig;
  const [showDialog, setShowDialog] = useState(false);
  const [disableText, setDisableText] = useState("");

  useEffect(() => {
    if (isDisabled && configType === "bosBuilder") {
      fetchTemporaryDisableText(hostnameConfig.hostname).then(setDisableText);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled, configType, hostnameConfig.hostname]);

  if (configType === "basicDeliveryTheme") {
    return (
      <SettingsCard title="Temporarily disable ordering">
        <p>You have menu-only BOS, please ask Admins to switch your BOS setting.</p>
      </SettingsCard>
    );
  }

  return (
    <SettingsCard title="Temporarily disable ordering">
      {isDisabled ? (
        <div>
          <p>Ordering is currently disabled with the below message. Click the button below to re-enable ordering.</p>
          {/* Owner-authored rich text from the BOS Builder, trusted the same way the legacy page trusts it. */}
          <div dangerouslySetInnerHTML={{ __html: disableText }} />
          <BbotButton type="primary" onClick={() => setShowDialog(true)} disabled={!canEdit}>
            Re-enable
          </BbotButton>
        </div>
      ) : (
        <div>
          <p>Click the button below to temporarily disable ordering.</p>
          <BbotButton type="primary" onClick={() => setShowDialog(true)} disabled={configType === "preBuilt"}>
            Temporarily Disable
          </BbotButton>
        </div>
      )}
      <TemporarilyDisableOrderingDialog
        visible={showDialog}
        enableOrdering={Boolean(isDisabled)}
        onClose={() => setShowDialog(false)}
        onConfirm={(richtext) => onTemporarilyDisableOrdering(hostnameConfig, Boolean(isDisabled), richtext)}
      />
    </SettingsCard>
  );
};

export default TemporarilyDisableOrderingCard;
